module.exports = __webpack_public_path__ + "img/test-status.dd669fca.png";